import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Race } from 'src/app/models/race';
import { RaceProgressLapMarkRaw, RaceProgressRegistration } from 'src/app/models';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-marks-table',
  templateUrl: './marks-table.component.html',
  styleUrls: ['./marks-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarksTableComponent implements OnInit {

  @Input() marks: RaceProgressLapMarkRaw[] = [];
  @Input() TVResume = false;
  @Input() selectedRace!: Race;
  @Input() time_state!: number;
  @Input() competitor!: RaceProgressRegistration;
  @Input() col: any;

  timeFormat = 'HH:mm:ss';

  constructor(public appSettings: SettingsService) { }

  ngOnInit() {
    if (this.selectedRace && this.selectedRace.showMillsInResults) this.timeFormat = 'HH:mm:ss.SSS';
  }

}
